import React from 'react'
import PropTypes from 'prop-types'

import AddToCartButton from 'Checkout/Cart/AddToCartButton'
import ModalVoltage from 'Catalog/Product/ProductDetail/RedemptionSection/ModalVoltage'
import { ChangeContext } from '../ChangeContext'

const AddCartVerify = ({ sku, vendorId, hasVoltage, changeContext }) => {
  if (changeContext) {
    return <ChangeContext />
  } else if (hasVoltage) {
    return <ModalVoltage sku={sku} vendorId={vendorId} />
  } else {
    return <AddToCartButton sku={sku} vendorId={vendorId} goToCheckout className='btn-featured' />
  }
}

AddCartVerify.propTypes = {
  sku: PropTypes.string,
  vendorId: PropTypes.string,
  hasVoltage: PropTypes.bool
}

export default AddCartVerify



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/AddCartVerify/index.js